export default "__VITE_ASSET__Dqn$8BAB__"